export default __webpack_public_path__ + "static/schedule-8c0278ea969caf7e8d99b818b843fd71.svg";